export function clamp(value: number, min: number, max: number) {
  return value < min ? min : value > max ? max : value;
}

export function clamp01(value: number) {
  return clamp(value, 0, 1);
}

export function lerp(a: number, b: number, t: number) {
  return a * (1 - t) + b * t;
}

export function theMinMaxMod(value: number, min: number, max: number) {
  const len = max - min;
  return ((((value - min) % len) + len) % len) + min;
}

export function AlmostEqual(a: number, b: number) {
  return Math.abs(a - b) < 0.25;
}
